<template>
  <div>
    <base-image-view ref="img-view" v-if="show" :initial-index="initIndex" :onClose="()=>show = false" :url-list="list" :zIndex="2200"/>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      initIndex: 0,
      list: []
    }
  },
  methods: {
    /*
    list 兼容 图片 / 压缩包
    index 图片默认浏览第几个 空则 第一个
    keyName list[n].keyName 空则取 list[n]
    isDownload 自动下载非图片压缩包等文件
     */
    open(list, index, keyName, isDownload) {
      const imgs = []
      const files = []
      list = list || []
      list.map(o => {
        const url = keyName ? o[keyName] : o
        if (o.match(/(^data\:image\/)|(\.(jpe?g|png|gif))/i)) {
          imgs.push(url)
        } else if (url) {
          files.push(url)
        }
      })
      if (imgs.length) {
        this.show = true
        this.list = imgs
        this.initIndex = index || 0
        try {
          if (this.$refs['img-view']) {
            this.$refs['img-view'].index = this.initIndex
          }
        } catch (err) { console.error(err) }
      }
      files.map(file => {
        isDownload && window.open(file)
      })
    }
  }

}
</script>
